import { ChevronRight, Ellipsis, Mars, Venus, type LucideIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import type { QuizStep } from "../../types"

const ICONS: Record<string, LucideIcon> = {
  mars: Mars,
  venus: Venus,
  ellipsis: Ellipsis,
}

interface Props {
  step: QuizStep
  value: string | undefined
  onChange: (value: string) => void
}

export function SingleChoiceStep({ step, value, onChange }: Props) {
  if (step.layout === "icons") {
    return (
      <div className="flex items-start justify-center gap-4">
        {step.options?.map((option) => {
          const Icon = option.icon ? ICONS[option.icon] : undefined
          const selected = value === option.value
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className="flex flex-1 flex-col items-center gap-2"
            >
              <span
                className={cn(
                  "flex size-26 items-center justify-center rounded-full backdrop-blur-md transition-colors",
                  selected ? "bg-main-purple text-white" : "bg-purple-light/10 text-purple-light",
                )}
              >
                {Icon ? <Icon className="size-14" /> : option.label.charAt(0)}
              </span>
              <span className="text-base font-semibold text-purple-light">{option.label}</span>
            </button>
          )
        })}
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {step.options?.map((option) => {
        const selected = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              "flex h-14 w-full items-center justify-between rounded-xl border px-4 text-left text-base transition-colors",
              step.boldOptions ? "font-bold" : "font-medium",
              selected
                ? "border-main-purple bg-purple-light/10 text-purple-light"
                : "border-transparent bg-purple-light/10 text-purple-light hover:bg-purple-light/15",
            )}
          >
            {option.label}
            <ChevronRight
              className={cn("size-5", selected ? "text-main-purple" : "text-purple-light/40")}
            />
          </button>
        )
      })}
    </div>
  )
}
